import http from './http';

export async function listAnnouncements() {
  const { data } = await http.get('/api/user/announcements');
  return data;
}

export async function confirmAnnouncement(id) {
  const { data } = await http.post(`/api/user/announcements/${id}/confirm`);
  return data;
}

export async function listAnnouncementsForRole(role) {
  const base = role === 'SECONDARY_HANDLER' ? '/api/secondary-handler/announcements' : '/api/user/announcements';
  const { data } = await http.get(base);
  return data;
}

export async function confirmAnnouncementForRole(role, id) {
  const base = role === 'SECONDARY_HANDLER' ? '/api/secondary-handler/announcements' : '/api/user/announcements';
  const { data } = await http.post(`${base}/${id}/confirm`);
  return data;
}
